import { useLocation } from '@reach/router';
import queryString from 'query-string';
import { LoginMethod } from '@/models/domain/AuthParams';

const getQuery = (search: string) => {
    const query = queryString.parse(search, {
        decode: true,
    });
    return Object.keys(query)
        .filter((key) => typeof query[key] === 'string')
        .reduce((prev, key) => {
            // eslint-disable-next-line no-param-reassign
            prev[key] = query[key] as string;
            return prev;
        }, {} as Record<string, string>);
};

/**
 * 現在のURLのパラメータ一覧をオブジェクトとして取得する
 */
export const useLocationSearch = () => {
    const location = useLocation();
    const {
        cloudId: inputCloudId,
        cloudid,
        loginId,
        origin,
        select,
        loginMethod,
        close,
        error,
        lambdaError,
        error_description: errorDescription,
    } = getQuery(location.search);

    // cloudIdを優先して採用する
    const cloudId = inputCloudId || cloudid;

    return {
        cloudId,
        loginId,
        origin,
        loginMethod: loginMethod as LoginMethod,
        select: select === 'true',
        close: close === 'true',
        error,
        lambdaError,
        errorDescription,
    };
};
